module.exports = __webpack_public_path__ + "static/media/logo-small.b0b77b31.png";